<template>
  <BaseCard :title="'RPG Battle Simulator'" :highlightLastWord="false">
    <div class="flex flex-col justify-center gap-4">
      <div class="w-full grid lg:grid-cols-2 lg:gap-20">
        <h5 class="lg:justify-self-end lg:pr-6 font-medium">Solo Engineer</h5>
        <h5 class="lg:justify-self-start lg:pl-6 font-medium">April 2025 - May 2025</h5>
      </div>

      <p class="text-center items-center px-4 gap-2">
        <span class="block">
          Battle simulator akin to Final Fantasy
        </span>
        <span class="block">
          X11 forwarding using solely C &amp; gfx graphics library
        </span>
        <span class="block">
          Interface with terminal for name input, then entirely inside the game afterwards
        </span>
        <span class="block">
          Unique pixel sprites, animated moves, menus, and classes
        </span>
        <a href="https://youtu.be/EPzwJwWxlPI" target="_blank" class="link-in-text">Watch a demo!</a>
      </p>
      <span class="grid lg:grid-cols-2 gap-12 w-full h-auto place-items-center overflow-hidden">
        <img class="w-full h-auto rounded-lg hidden lg:block cursor-pointer" :src="FFSS1" @click="openImageMenu(FFSS1, 'Battle Sim Screenshot 1', $event.currentTarget)">
        <img class="w-full h-auto rounded-lg cursor-pointer" :src="FFSS3" @click="openImageMenu(FFSS3, 'Battle Sim Screenshot 2', $event.currentTarget)">
      </span>
    </div>
  </BaseCard>
</template>

<script lang="ts" setup>
import BaseCard from '@/features/global/BaseCard.vue';
import FFSS1 from '@/assets/Projects/FinalFantasyPhotos/FFSS1.png';
import FFSS3 from '@/assets/Projects/FinalFantasyPhotos/FFSS3.png';
import { useImageViewer } from '@/features/composables/useImageViewer';

const { openImageMenu } = useImageViewer();
</script>